import { BrowserInfo, detect } from 'detect-browser';

type OperatingSystem = NonNullable<BrowserInfo['os']>;
type Browser = NonNullable<BrowserInfo['name']>;
const supportedBrowsers: Browser[] = [
  'chrome',
  'firefox',
  'android',
  'edge-chromium',
  'ios',
  'ios-webview',
];
const supportedOs: OperatingSystem[] = ['iOS', 'Android OS'];

const current: BrowserInfo = detect() as BrowserInfo;

const isSupported =
  current != null &&
  (supportedBrowsers.includes(current.name) ||
    (current.os != null && supportedOs.includes(current.os)));

export const browserInfo = {
  isSupported,
  current,
};
